import { Instance } from 'mobx-state-tree';
import { ProjectStopsUnscheduledDtoModelBase } from './ProjectStopsUnscheduledDtoModel.base';

/* The TypeScript type of an instance of ProjectStopsUnscheduledDtoModel */
export interface ProjectStopsUnscheduledDtoModelType extends Instance<typeof ProjectStopsUnscheduledDtoModel.Type> {}

/* A graphql query fragment builders for ProjectStopsUnscheduledDtoModel */
export { selectFromProjectStopsUnscheduledDto, projectStopsUnscheduledDtoModelPrimitives, ProjectStopsUnscheduledDtoModelSelector } from './ProjectStopsUnscheduledDtoModel.base';

/**
 * ProjectStopsUnscheduledDtoModel
 */
export const ProjectStopsUnscheduledDtoModel = ProjectStopsUnscheduledDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
